module.exports = __webpack_public_path__ + "img/01.0b667d1d.png";